
import { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useAuth } from "@/contexts/AuthContext";
import { PresenceProvider } from "@/contexts/PresenceContext";
import { SidebarProvider, useSidebar } from "@/contexts/SidebarContext";
import LoadingScreen from "@/components/LoadingScreen";
import RouteSeo from "@/components/RouteSeo";

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayoutContent = ({ children }: AppLayoutProps) => {
  const { loading } = useAuth();
  const { isOpen } = useSidebar();
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  
  // Set a short timeout to prevent flash of incorrect auth state
  useEffect(() => {
    if (!loading) {
      // Small delay to ensure auth state is fully propagated
      const timer = setTimeout(() => setIsInitialLoading(false), 100);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  if (isInitialLoading || loading) {
    return <LoadingScreen message="Loading your session..." />;
  }

  return (
    <PresenceProvider>
      <RouteSeo />
      <div 
        className={`min-h-screen flex flex-col bg-background text-foreground transition-all duration-300 ease-in-out ${isOpen ? 'w-[calc(100vw-80px)]' : 'w-full'}`}
      >
        <Navbar />
        <main className="flex-grow">
          {children}
        </main>
        <Footer />
      </div>
    </PresenceProvider>
  );
};

const AppLayout = ({ children }: AppLayoutProps) => {
  return (
    <SidebarProvider>
      <AppLayoutContent>{children}</AppLayoutContent>
    </SidebarProvider>
  );
};

export default AppLayout;
